<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header btn-holder tab-nav-holder">
      <div class="col-sm-12 nav-tab-holder">
        <ul class="nav nav-tabs" role="tablist">
          <li>
            <a
              (click)="tab = tabs.Calendar"
              [class.active]="tab === tabs.Calendar"
              matTooltip="A Standard Calendar showing rates for all rate categories."
              matTooltipPosition="below"
              matTooltipClass="text-center"
            >
              Rates Calendar
            </a>
          </li>
          <li>
            <a
              (click)="tab = tabs.Rates"
              [class.active]="tab === tabs.Rates"
              matTooltip="All rates and rate periods shown in tabular format."
              matTooltipPosition="below"
              matTooltipClass="text-center"
            >
              Rates Table
            </a>
          </li>
          <li>
            <a
              (click)="tab = tabs.RateMappings"
              [class.active]="tab === tabs.RateMappings"
              matTooltip="Rate Maps allow you to streamline the pushing of rates to connected channels. Once you have created your rate maps you may then update all connected channels by clicking the Push Rates button at right. Rate Maps are also used to automatically update channel rates if you use Dynamic Rates. You must, however, enable auto sync for the rates to be automatically updated."
              matTooltipPosition="below"
              matTooltipClass="text-center"
            >
              Rate Mappings
            </a>
          </li>
          <li *ngIf="showDiscounts">
            <a
              (click)="tab = tabs.Discounts"
              [class.active]="tab === tabs.Discounts"
              matTooltip="All discounts for this rental"
              matTooltipPosition="below"
              matTooltipClass="text-center"
            >
              Discounts
            </a>
          </li>
          <li>
            <a
              (click)="tab = tabs.Settings"
              [class.active]="tab === tabs.Settings"
              [matTooltip]="
                hasIncompleteBaseRate
                  ? 'Base Rate settings are required to ensure your rate mappings and future rate pushes go through properly. Please make sure that a nightly rate and minimum stay are set on this tab even if you have no plans to use the Base Settings as a default rate.'
                  : 'Adjust the Base Rate settings for your rental.'
              "
              matTooltipPosition="below"
              matTooltipClass="text-center"
            >
              <i *ngIf="hasIncompleteBaseRate" class="fal fa-exclamation-triangle"></i> Settings
            </a>
          </li>
        </ul>
      </div>
      <a (click)="close()" class="cstm-close" data-dismiss="modal" aria-label="Close">
        <span class="fas fa-times"></span>
      </a>
    </div>

    <div class="modal-body">
      <div *ngIf="rental" class="tab-content">
        <app-rental-rates-calendar *ngIf="tab === tabs.Calendar" [rental]="rental" [loading]="!initialized">
        </app-rental-rates-calendar>

        <app-rates-table *ngIf="tab === tabs.Rates" [rental]="rental" (changeRates)="onChangeRates()">
        </app-rates-table>

        <app-rental-rate-mappings-table *ngIf="tab === tabs.RateMappings" [rental]="rental">
        </app-rental-rate-mappings-table>

        <app-rental-discounts *ngIf="tab === tabs.Discounts" [rental]="rental"> </app-rental-discounts>

        <app-rental-rate-settings *ngIf="tab === tabs.Settings" (changeBaseRate)="onChangeRates()" [rental]="rental">
        </app-rental-rate-settings>
      </div>
    </div>
  </div>
</div>
